
export const getCheckinCode = (ticket) => {
  try {
    const qr = ticket.references && ticket.references.find((reference) => reference.type === 'qr');
    if (qr) {
      return {
        ...JSON.parse(qr.reference),
        type: 'qr',
      };
    }
    const barcode = ticket.references && ticket.references.find((reference) => reference.type === 'barcode');
    if (barcode) {
      return {
        ...JSON.parse(barcode.reference),
        type: 'barcode',
      };
    }
  } catch (ex) {
    return undefined;
  }

  const tixrRef = ticket.references && ticket.references.find((reference) => reference.type === 'tixr_serial_number');
  const shopRef = ticket.references && ticket.references.find((reference) => reference.type === 'unique_ticket_id');
  const t4fRef = ticket.references && ticket.references.find((reference) => reference.type === 't4f_ticket_number');
  const sevillaRef = ticket.references && ticket.references.find((reference) => reference.type === 'sevilla_qr_code');

  const plainRef = tixrRef || t4fRef || sevillaRef || shopRef;

  if (plainRef) {
    return {
      code: plainRef.reference,
      text: plainRef.reference,
      type: t4fRef ? 'bar' : 'qr',
      provider: t4fRef ? 'T4f' : 'Tixr',
    };
  }
  return undefined;
};

export default null;
